module.exports = __webpack_public_path__ + "img/05.f667ec76.jpg";